import { GroupSecurity } from '@quromedical/fhir-common';
import type { PatientRouteParams } from 'app/routes';
import { SkeletonProvider, Tabs } from 'design-system';
import { useGlobalSearchParams } from 'expo-router';
import { useUserSession } from 'hooks/useUserSession';
import type { PatientDrawerScreenProps } from 'navigation';
import type React from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';

import { DocumentTab } from './tabs';

export const DocumentScreen: React.FC<
  PatientDrawerScreenProps<'Documents'>
> = () => {
  const { patientId } = useGlobalSearchParams<PatientRouteParams>();
  const session = useUserSession();

  const hasDocumentPermissions = session.hasAny([
    GroupSecurity.DocumentReferenceRead,
  ]);

  return (
    <ScrollView>
      <SkeletonProvider loading={false}>
        <Tabs.Group>
          <Tabs.Screen
            isHidden={!hasDocumentPermissions}
            title={strings.DocumentListTitle}
          >
            <DocumentTab patientId={patientId} />
          </Tabs.Screen>
        </Tabs.Group>
      </SkeletonProvider>
    </ScrollView>
  );
};
